/* =======================================
   NAVEGACIÓN UNIFICADA JS - PUBLIKAYA
   Funcionalidad del menú responsive
   ======================================= */

(function() {
    'use strict';

    // Silenciar logs solo fuera de desarrollo (mantener warnings/errores)
    try {
        const isDev = /localhost|127\.0\.0\.1/.test(window.location.hostname) || window.DEBUG === true;
        if (!isDev) {
            const noop = function(){};
            console.log = noop;
            console.info = noop;
            console.debug = noop;
        }
    } catch(_) {}

    /**
     * Inyecta estilos y lógica para colapsar slots de AdSense vacíos
     * Evita huecos cuando no se sirve anuncio o hay bloqueadores
     */
    function ensureAdCollapse(){
        try {
            const selectors = [
                'ins.adsbygoogle',
                '.adsbygoogle',
                '#adsbygoogle',
                '[id^="google_ads" i]'
            ];

            const hasAdSlots = selectors.some(sel => {
                try { return !!document.querySelector(sel); } catch { return false; }
            });
            if (!hasAdSlots) return;

            const startedAt = Date.now();

            // Inyectar CSS una sola vez
            if (!document.getElementById('adsense-collapse-styles')) {
                const css = `.ad-collapsed{display:none!important;height:0!important;min-height:0!important;margin:0!important;padding:0!important}`;
                const style = document.createElement('style');
                style.id = 'adsense-collapse-styles';
                style.textContent = css;
                document.head.appendChild(style);
            }

            // Función para evaluar y colapsar un slot
            // SIN forced reflow — usa data-ad-status (ya lo pone AdSense) y textContent
            const collapse = (el) => {
                if (!el) return;
                try {
                    // Si AdSense marca el estado, respetarlo (0 reflow)
                    const adStatus = (el.getAttribute && el.getAttribute('data-ad-status')) ? String(el.getAttribute('data-ad-status')).toLowerCase() : '';
                    if (adStatus === 'filled') {
                        el.classList.remove('ad-collapsed');
                        const p0 = el.parentElement;
                        if (p0 && p0.classList) p0.classList.remove('ad-collapsed');
                        return;
                    }
                    if (adStatus === 'unfilled') {
                        el.classList.add('ad-collapsed');
                        const p1 = el.parentElement;
                        if (p1 && /adsbygoogle|ad-slot|google_ads/i.test(p1.className + ' ' + (p1.id || ''))) {
                            p1.classList.add('ad-collapsed');
                        }
                        return;
                    }

                    // Sin data-ad-status: usar textContent (0 reflow) y edad
                    const isEmpty = (el.textContent || '').trim() === '';
                    const ageMs = Date.now() - startedAt;
                    if (isEmpty && ageMs >= 6000) {
                        el.classList.add('ad-collapsed');
                        const p = el.parentElement;
                        if (p && /adsbygoogle|ad-slot|google_ads/i.test(p.className + ' ' + (p.id || ''))) {
                            p.classList.add('ad-collapsed');
                        }
                    } else if (!isEmpty) {
                        el.classList.remove('ad-collapsed');
                        const p2 = el.parentElement;
                        if (p2 && p2.classList) p2.classList.remove('ad-collapsed');
                    }
                } catch(_) {}
            };

            const scan = () => {
                const nodes = document.querySelectorAll('ins.adsbygoogle, .adsbygoogle, [id^="google_ads" i]');
                nodes.forEach(collapse);
            };

            // Escaneos escalonados para dar tiempo a AdSense
            [2500, 6000, 10000, 18000].forEach(function(t) { return setTimeout(scan, t); });

            // Observer limitado a contenedores de anuncios (no todo el DOM)
            try {
              var adContainers = document.querySelectorAll('[class*="ad-"], [id*="ad-"], .ads, [class*="banner"]');
              if (adContainers.length > 0) {
                var mo = new MutationObserver(function() { scan(); });
                adContainers.forEach(function(el) {
                  mo.observe(el, { childList: true, subtree: false });
                });
                // Limpiar observer después de 30s
                setTimeout(function() { try { mo.disconnect(); } catch(_) {} }, 30000);
              }
            } catch(_) {}

            // Escaneo final de seguridad
            setTimeout(scan, 30000);
        } catch(_) {}
    }

    // Variables globales
    const isDashboard = (function(){
        try { return (document.body && document.body.dataset && document.body.dataset.context === 'dashboard'); }
        catch { return false; }
    })();
    let mobileMenuToggle;
    let mobileMenu;
    let mobileOverlay;
    let dashboardSidebar;
    let dashboardOverlay;
    let header;
    let dropdowns;
    let isMenuOpen = false;
    // Cache de altura del header para evitar lecturas de layout repetidas
    let headerHeightCached = 70;
    // Cache del viewport width para evitar reprocesamiento
    let viewportWidth = window.innerWidth;
    let resizeTimeout;
    // Soporte para ResizeObserver
    const hasResizeObserver = typeof ResizeObserver !== 'undefined';
    // Soporte para IntersectionObserver
    const hasIntersectionObserver = typeof IntersectionObserver !== 'undefined';

    // Helper para agrupar escrituras en el próximo frame y evitar reflows
    const writeDOM = (cb) => {
        if (typeof requestAnimationFrame === 'function') {
            requestAnimationFrame(cb);
        } else {
            setTimeout(cb, 0);
        }
    };

    // Inicialización cuando el DOM esté listo
    document.addEventListener('DOMContentLoaded', function() {
        initNavigation();
    });

    /**
     * Inicializa toda la funcionalidad de navegación
     */
    function initNavigation() {
        // Obtener elementos del DOM
        mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
        mobileMenu = document.querySelector('.mobile-menu');
        mobileOverlay = document.querySelector('.mobile-overlay');
        // Referencias del dashboard (menú oscuro)
        dashboardSidebar = document.getElementById('sidebar');
        dashboardOverlay = document.getElementById('sidebar-overlay');
        header = document.querySelector('.header');
        dropdowns = document.querySelectorAll('.dropdown');

        // Configurar event listeners
        setupEventListeners();
        
        // Configurar scroll del header con IO si está disponible
        if (hasIntersectionObserver) {
            setupHeaderScrollObserver();
        } else {
            setupHeaderScroll();
        }
        
        // Configurar dropdowns
        setupDropdowns();
        
        // Marcar página actual
        if (!isDashboard) {
            markCurrentPage();
        }
        
        // Configurar accesibilidad
        setupAccessibility();
        
        // Configurar autenticación dinámica
        if (!isDashboard) {
            setupAuthenticationUI();
        }

        if (!isDashboard) {
            applyPublicHardening();
        }

        // Inyectar flecha "scroll-to-top" en todas las páginas
        ensureScrollToTop();

        // Colapsar espacios vacíos de AdSense en todas las páginas
        try {
            const runAdCollapse = () => { try { ensureAdCollapse(); } catch(_) {} };
            const schedule = () => {
                try {
                    if ('requestIdleCallback' in window) {
                        window.requestIdleCallback(runAdCollapse, { timeout: 5000 });
                    } else {
                        setTimeout(runAdCollapse, 5000);
                    }
                } catch(_) {
                    setTimeout(runAdCollapse, 5000);
                }
            };
            if (document.readyState === 'complete') {
                schedule();
            } else {
                window.addEventListener('load', schedule, { once: true });
            }
        } catch(_) {
            setTimeout(() => { try { ensureAdCollapse(); } catch(__) {} }, 5000);
        }

        // Inyectar enlace de Donaciones en el footer general (si existe y no está ya)
        try { addDonationFooterLink(); } catch(_){}

        // Inicializar caché de altura sin lecturas de layout sincrónicas
        try {
            const mqMobile = window.matchMedia('(max-width: 768px)');
            headerHeightCached = mqMobile.matches ? 60 : 70;
            // Actualizar al cambiar el breakpoint sin lecturas de layout
            if (typeof mqMobile.addEventListener === 'function') {
                mqMobile.addEventListener('change', (e) => {
                    headerHeightCached = e.matches ? 60 : 70;
                });
            } else if (typeof mqMobile.addListener === 'function') {
                // Soporte legacy
                mqMobile.addListener((e) => {
                    headerHeightCached = e.matches ? 60 : 70;
                });
            }
        } catch (err) {
            headerHeightCached = 70;
        }

        // Observar cambios reales en la altura del header sin forzar layout
        if (header && hasResizeObserver) {
            const ro = new ResizeObserver((entries) => {
                for (const entry of entries) {
                    const boxed = entry.borderBoxSize && entry.borderBoxSize[0] && entry.borderBoxSize[0].blockSize;
                    const h = boxed || entry.contentRect.height;
                    headerHeightCached = Math.round(h || 70);
                    // Actualizar scroll-padding-top para evitar cálculos en scroll suave
                    try {
                        document.documentElement.style.scrollPaddingTop = (headerHeightCached + 20) + 'px';
                    } catch(_){}
                }
            });
            ro.observe(header);
        } else if (header && !hasResizeObserver) {
            // Fallback sincrónico diferido para evitar forzar layout en init
            const measure = () => {
                const read = () => {
                    const h = header.getBoundingClientRect().height;
                    if (h) headerHeightCached = Math.round(h);
                    try {
                        document.documentElement.style.scrollPaddingTop = (headerHeightCached + 20) + 'px';
                    } catch(_){}
                };
                if ('requestIdleCallback' in window) {
                    window.requestIdleCallback(read, { timeout: 500 });
                } else {
                    requestAnimationFrame(read);
                }
            };
            measure();
        }
        
        /* Navegación unificada inicializada */
    }

    /**
     * Asegura que el widget de scroll-to-top esté cargado en todas las páginas
     */
    function ensureScrollToTop(){
        try {
            // El scroll-to-top ahora está inline en cada artículo, no necesitamos cargar script externo
            if (window.__scrollToTopInjected) return;
            // Verificar si ya existe el botón en el DOM
            if (document.querySelector('.to-top')) {
                window.__scrollToTopInjected = true;
                return;
            }
        } catch(_) {}
    }

    /**
     * Configura todos los event listeners
     */
    function setupEventListeners() {
        // Toggle del menú móvil
        if (mobileMenuToggle) {
            mobileMenuToggle.addEventListener('click', function(e){
                e.preventDefault();
                e.stopPropagation();
                
                // En dashboard, delegar en DashboardSidebar si existe
                if (isDashboard && typeof window !== 'undefined' && window.DashboardSidebar) {
                    // Evitar doble toggle por listeners duplicados (sidebar.js también escucha)
                    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
                    window.DashboardSidebar.toggle();
                    return;
                }
                toggleMobileMenu();
            });
        }

        // Cerrar menú al hacer click en el botón de cierre dentro del menú móvil
        const mobileMenuCloseBtn = document.querySelector('.mobile-menu-close');
        if (mobileMenuCloseBtn) {
            mobileMenuCloseBtn.addEventListener('click', function(e){
                try {
                    e.preventDefault();
                    e.stopPropagation();
                } catch(_) {}
                closeMobileMenu();
            });
        }

        // Cerrar menú al hacer click en overlay
        if (mobileOverlay) {
            mobileOverlay.addEventListener('click', closeMobileMenu);
        }
        if (isDashboard && dashboardOverlay) {
            // Evitar duplicar listener si DashboardSidebar controla el overlay
            if (!(typeof window !== 'undefined' && window.DashboardSidebar)) {
                dashboardOverlay.addEventListener('click', closeMobileMenu);
            }
        }

        // Cerrar menú al hacer click en enlaces del menú móvil
        const mobileMenuItems = document.querySelectorAll('.mobile-menu-item');
        mobileMenuItems.forEach(item => {
            item.addEventListener('click', () => {
                setTimeout(closeMobileMenu, 120);
            });
        });

        // DASHBOARD: cerrar al tocar item del sidebar (data-section o links)
        if (isDashboard && dashboardSidebar) {
            // Si DashboardSidebar existe, ya cierra al hacer click en items
            if (!(typeof window !== 'undefined' && window.DashboardSidebar)) {
                const sidebarItems = dashboardSidebar.querySelectorAll('[data-section], a[href]');
                sidebarItems.forEach(el => {
                    el.addEventListener('click', () => {
                        setTimeout(closeMobileMenu, 120);
                    });
                });
            }
        }

        // Cerrar con Escape
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && isMenuOpen) {
                closeMobileMenu();
            }
        });

        // Cerrar dropdowns al hacer click fuera
        document.addEventListener('click', function(e) {
            if (!e.target.closest('.dropdown')) {
                closeAllDropdowns();
            }
        });

        // Resize handler optimizado con throttling
        window.addEventListener('resize', function() {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                const newWidth = window.innerWidth;
                if (newWidth !== viewportWidth) {
                    viewportWidth = newWidth;
                    if (viewportWidth > 768 && isMenuOpen) {
                        closeMobileMenu();
                    }
                    // Fallback: si no hay ResizeObserver, medir en el próximo frame para evitar forced reflow
                    if (!hasResizeObserver && header) {
                        requestAnimationFrame(() => {
                            const h = header.getBoundingClientRect().height;
                            if (h) headerHeightCached = Math.round(h);
                            try {
                                document.documentElement.style.scrollPaddingTop = (headerHeightCached + 20) + 'px';
                            } catch(_){}
                        });
                    }
                }
            }, 100);
        });
    }

    /**
     * Configura el efecto de scroll en el header con optimización
     */
    function setupHeaderScroll() {
        if (!header) return;

        let lastScrollY = window.scrollY;
        let ticking = false;
        let scrollThreshold = headerHeightCached;

        function updateHeader() {
            const currentScrollY = window.scrollY;
            
            // Solo actualizar si hay cambio significativo
            if (Math.abs(currentScrollY - lastScrollY) > 5) {
                if (currentScrollY > scrollThreshold) {
                    if (!header.classList.contains('scrolled')) {
                        header.classList.add('scrolled');
                    }
                } else {
                    if (header.classList.contains('scrolled')) {
                        header.classList.remove('scrolled');
                    }
                }
                lastScrollY = currentScrollY;
            }
            
            ticking = false;
        }

        function requestTick() {
            if (!ticking) {
                requestAnimationFrame(updateHeader);
                ticking = true;
            }
        }

        window.addEventListener('scroll', requestTick, { passive: true });
    }

    /**
     * Alternativa eficiente con IntersectionObserver para el estado 'scrolled' del header
     */
    function setupHeaderScrollObserver() {
        if (!header) return;
        // Crear un sentinel en el top del documento
        let sentinel = document.getElementById('header-scroll-sentinel');
        if (!sentinel) {
            sentinel = document.createElement('div');
            sentinel.id = 'header-scroll-sentinel';
            // Tamaño mínimo para observar cruce
            sentinel.style.cssText = 'position:absolute;top:0;left:0;width:1px;height:1px;pointer-events:none;opacity:0;';
            document.body.prepend(sentinel);
        }

        const io = new IntersectionObserver((entries) => {
            const entry = entries[0];
            // Cuando el sentinel deja de estar visible por encima de 50px, marcamos 'scrolled'
            if (entry.isIntersecting) {
                header.classList.remove('scrolled');
            } else {
                header.classList.add('scrolled');
            }
        }, {
            root: null,
            rootMargin: '-50px 0px 0px 0px',
            threshold: 0
        });

        io.observe(sentinel);
    }

    /**
     * Configura la funcionalidad de los dropdowns
     */
    function setupDropdowns() {
        dropdowns.forEach(dropdown => {
            const toggle = dropdown.querySelector('.dropdown-toggle');
            const menu = dropdown.querySelector('.dropdown-menu');
            
            if (toggle && menu) {
                // Click en el toggle
                toggle.addEventListener('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    
                    const isActive = dropdown.classList.contains('active');
                    
                    // Cerrar todos los dropdowns
                    closeAllDropdowns();
                    
                    // Abrir este dropdown si no estaba activo
                    if (!isActive) {
                        dropdown.classList.add('active');
                    }
                });

                // Configurar hover para desktop - usar viewport cacheado
                if (viewportWidth > 768) {
                    dropdown.addEventListener('mouseenter', function() {
                        closeAllDropdowns();
                        dropdown.classList.add('active');
                    });

                    dropdown.addEventListener('mouseleave', function() {
                        dropdown.classList.remove('active');
                    });
                }
            }
        });
    }

    /**
     * Cierra todos los dropdowns de forma optimizada
     */
    function closeAllDropdowns() {
        // Usar DocumentFragment para batch DOM updates
        const activeDropdowns = document.querySelectorAll('.dropdown.active');
        activeDropdowns.forEach(dropdown => {
            dropdown.classList.remove('active');
        });
    }

    /**
     * Alterna el estado del menú móvil
     */
    function toggleMobileMenu() {
        if (isMenuOpen) {
            closeMobileMenu();
        } else {
            openMobileMenu();
        }
    }

    function applyPublicHardening() {
        try {
            document.querySelectorAll('a[href^="javascript:" i]').forEach((a) => {
                try {
                    a.setAttribute('href', '#');
                } catch(_) {}
            });
        } catch(_) {}

        try {
            const socialButtons = document.querySelectorAll('.social-share .social-share-btn[onclick]');
            socialButtons.forEach((el) => {
                try { el.removeAttribute('onclick'); } catch(_) {}
            });

            const faqItems = document.querySelectorAll('.faq-accordion .faq-item[onclick]');
            faqItems.forEach((el) => {
                try { el.removeAttribute('onclick'); } catch(_) {}
            });

            const langToggles = document.querySelectorAll('#langSwitcher .lang-toggle-btn[onclick], .language-switcher .lang-toggle-btn[onclick]');
            langToggles.forEach((el) => {
                try { el.removeAttribute('onclick'); } catch(_) {}
            });

            const legacyToTop = document.querySelectorAll('.to-top[onclick]');
            legacyToTop.forEach((el) => {
                try { el.removeAttribute('onclick'); } catch(_) {}
            });
        } catch(_) {}

        try {
            if (!window.__pyaPublicHardeningBound) {
                window.__pyaPublicHardeningBound = true;
                document.addEventListener('click', (e) => {
                    const shareBtn = e.target && e.target.closest ? e.target.closest('.social-share .social-share-btn') : null;
                    if (shareBtn) {
                        try {
                            e.preventDefault();
                            const shimEvent = {
                                preventDefault: () => { try { e.preventDefault(); } catch(_) {} },
                                currentTarget: shareBtn,
                                target: e.target || shareBtn
                            };
                            if (shareBtn.classList.contains('twitter')) {
                                if (typeof window.shareOnTwitter === 'function') {
                                    window.shareOnTwitter(shimEvent);
                                    return;
                                }
                                const pageUrl = encodeURIComponent(window.location.href);
                                const text = encodeURIComponent('Descubre contenido en PublikaYA');
                                window.open(`https://twitter.com/intent/tweet?url=${pageUrl}&text=${text}`, '_blank', 'width=550,height=420');
                                return;
                            }
                            if (shareBtn.classList.contains('facebook')) {
                                if (typeof window.shareOnFacebook === 'function') {
                                    window.shareOnFacebook(shimEvent);
                                    return;
                                }
                                const pageUrl = encodeURIComponent(window.location.href);
                                window.open(`https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`, '_blank', 'width=550,height=420');
                                return;
                            }
                            if (shareBtn.classList.contains('linkedin')) {
                                if (typeof window.shareOnLinkedIn === 'function') {
                                    window.shareOnLinkedIn(shimEvent);
                                    return;
                                }
                                const pageUrl = encodeURIComponent(window.location.href);
                                window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${pageUrl}`, '_blank', 'width=550,height=420');
                                return;
                            }
                            if (shareBtn.classList.contains('whatsapp')) {
                                if (typeof window.shareOnWhatsApp === 'function') {
                                    window.shareOnWhatsApp(shimEvent);
                                    return;
                                }
                                const pageUrl = encodeURIComponent(window.location.href);
                                const text = encodeURIComponent('Mira esto en PublikaYA: ');
                                window.open(`https://wa.me/?text=${text}${pageUrl}`, '_blank');
                                return;
                            }
                            if (shareBtn.classList.contains('copy') && navigator.clipboard) {
                                if (typeof window.copyLink === 'function') {
                                    window.copyLink(shimEvent);
                                    return;
                                }
                                navigator.clipboard.writeText(window.location.href).then(() => {
                                    try { shareBtn.classList.add('copied'); } catch(_) {}
                                    try {
                                        const icon = shareBtn.querySelector('i');
                                        if (icon) icon.className = 'fas fa-check';
                                    } catch(_) {}
                                    setTimeout(() => {
                                        try { shareBtn.classList.remove('copied'); } catch(_) {}
                                        try {
                                            const icon = shareBtn.querySelector('i');
                                            if (icon) icon.className = 'fas fa-link';
                                        } catch(_) {}
                                    }, 2000);
                                }).catch(() => {});
                                return;
                            }
                        } catch(_) {}
                    }

                    const faqClickable = e.target && e.target.closest ? e.target.closest('.faq-accordion .faq-question, .faq-accordion .faq-item') : null;
                    if (faqClickable) {
                        const item = faqClickable.classList && faqClickable.classList.contains('faq-item')
                            ? faqClickable
                            : faqClickable.closest('.faq-item');
                        if (!item) return;
                        const accordion = item.closest('.faq-accordion');
                        const all = accordion ? accordion.querySelectorAll('.faq-item') : [];
                        const isOpen = item.classList.contains('open');

                        all.forEach((it) => {
                            try {
                                it.classList.remove('open');
                                const btn = it.querySelector('.faq-question');
                                if (btn) btn.setAttribute('aria-expanded', 'false');
                                const ans = it.querySelector('.faq-answer');
                                if (ans && ans.style) ans.style.maxHeight = null;
                            } catch(_) {}
                        });

                        if (!isOpen) {
                            try {
                                item.classList.add('open');
                                const btn = item.querySelector('.faq-question');
                                if (btn) btn.setAttribute('aria-expanded', 'true');
                                const ans = item.querySelector('.faq-answer');
                                if (ans && ans.style) ans.style.maxHeight = ans.scrollHeight + 'px';
                            } catch(_) {}
                        }
                        return;
                    }

                    const langBtn = e.target && e.target.closest ? e.target.closest('#langSwitcher .lang-toggle-btn, .language-switcher .lang-toggle-btn') : null;
                    if (langBtn) {
                        try {
                            if (typeof window.toggleLangMenu === 'function') {
                                window.toggleLangMenu();
                                return;
                            }
                        } catch(_) {}
                        return;
                    }

                    const toTop = e.target && e.target.closest ? e.target.closest('.to-top') : null;
                    if (toTop) {
                        try {
                            if (typeof window.scrollToTop === 'function') {
                                window.scrollToTop();
                            } else {
                                window.scrollTo({ top: 0, behavior: 'smooth' });
                            }
                        } catch(_) {}
                        return;
                    }
                }, { capture: true });
            }
        } catch(_) {}
    }

    /**
     * Abre el menú móvil
     */
    function openMobileMenu() {
        if (isDashboard) {
            // Delegar completamente en DashboardSidebar si existe
            if (typeof window !== 'undefined' && window.DashboardSidebar && typeof window.DashboardSidebar.open === 'function') {
                window.DashboardSidebar.open();
                if (mobileMenuToggle) mobileMenuToggle.setAttribute('aria-expanded', 'true');
                isMenuOpen = true;
                return;
            }
            // Fallback legacy (si no existe DashboardSidebar)
            if (!dashboardSidebar || !dashboardOverlay || !mobileMenuToggle) return;
            isMenuOpen = true;
            writeDOM(() => {
                dashboardSidebar.classList.add('open');
                dashboardOverlay.classList.add('active');
                mobileMenuToggle.classList.add('active');
                document.body.style.overflow = 'hidden';
            });
            const firstSidebarItem = dashboardSidebar.querySelector('[data-section]');
            if (firstSidebarItem) {
                setTimeout(() => firstSidebarItem.focus && firstSidebarItem.focus(), 300);
            }
            mobileMenuToggle.setAttribute('aria-expanded', 'true');
            return;
        }

        if (!mobileMenu || !mobileOverlay || !mobileMenuToggle) return;

        isMenuOpen = true;
        writeDOM(() => {
            mobileMenu.classList.add('active');
            mobileOverlay.classList.add('active');
            mobileMenuToggle.classList.add('active');
            document.body.style.overflow = 'hidden';
        });
        const firstMenuItem = mobileMenu.querySelector('.mobile-menu-item');
        if (firstMenuItem) {
            setTimeout(() => firstMenuItem.focus(), 300);
        }
        mobileMenuToggle.setAttribute('aria-expanded', 'true');
    }

    /**
     * Cierra el menú móvil
     */
    function closeMobileMenu() {
        if (isDashboard) {
            // Delegar en DashboardSidebar si existe
            if (typeof window !== 'undefined' && window.DashboardSidebar && typeof window.DashboardSidebar.close === 'function') {
                window.DashboardSidebar.close();
                if (mobileMenuToggle) mobileMenuToggle.setAttribute('aria-expanded', 'false');
                isMenuOpen = false;
                return;
            }
            // Fallback legacy (si no existe DashboardSidebar)
            if (!dashboardSidebar || !dashboardOverlay || !mobileMenuToggle) return;
            isMenuOpen = false;
            writeDOM(() => {
                dashboardSidebar.classList.remove('open');
                dashboardOverlay.classList.remove('active');
                mobileMenuToggle.classList.remove('active');
                document.body.style.overflow = '';
            });
            mobileMenuToggle.setAttribute('aria-expanded', 'false');
            return;
        }

        if (!mobileMenu || !mobileOverlay || !mobileMenuToggle) return;
        isMenuOpen = false;
        writeDOM(() => {
            mobileMenu.classList.remove('active');
            mobileOverlay.classList.remove('active');
            mobileMenuToggle.classList.remove('active');
            document.body.style.overflow = '';
        });
        mobileMenuToggle.setAttribute('aria-expanded', 'false');
    }

    /**
     * Marca la página actual en el menú
     */
    function markCurrentPage() {
        const currentPath = window.location.pathname;
        const currentPage = currentPath.split('/').pop() || 'index.html';
        
        // Marcar en menú desktop
        const desktopLinks = document.querySelectorAll('.nav-link');
        desktopLinks.forEach(link => {
            const href = link.getAttribute('href');
            if (href && (href === currentPage || 
                        (currentPage === '' && href === 'index.html') ||
                        (currentPage === 'index.html' && href === '/'))) {
                link.classList.add('current-page');
            }
        });
        
        // Marcar en menú móvil
        const mobileLinks = document.querySelectorAll('.mobile-menu-item');
        mobileLinks.forEach(link => {
            const href = link.getAttribute('href');
            if (href && (href === currentPage || 
                        (currentPage === '' && href === 'index.html') ||
                        (currentPage === 'index.html' && href === '/'))) {
                link.classList.add('active');
            }
        });
    }

    /**
     * Función auxiliar para verificar el tipo de usuario
     */
    function hasSessionHint() {
        try {
            return /(?:^|; )__Host-session_hint=/.test(document.cookie || '') || /(?:^|; )session_hint=/.test(document.cookie || '');
        } catch (_) {
            return false;
        }
    }

    function clearLegacyTokens() {
        try { localStorage.removeItem('access_token'); } catch(_) {}
        try { localStorage.removeItem('refresh_token'); } catch(_) {}
        try { localStorage.removeItem('user_data'); } catch(_) {}
    }

    function clearSessionHintCookie() {
        try {
            document.cookie = '__Host-session_hint=; Max-Age=0; path=/; Secure; SameSite=Lax';
            document.cookie = 'session_hint=; Max-Age=0; path=/; SameSite=Lax';
            document.cookie = 'session_hint=; Max-Age=0; path=/; SameSite=Lax; Secure';
        } catch (_) {}
    }

    async function checkUserTypeForMenu() {
        const token = getAccessToken();

        if (!hasSessionHint()) {
            clearLegacyTokens();
            return null;
        }

        try {
            const apiUrl = getApiBaseURL();

            const headers = {};
            if (token) headers['Authorization'] = `Bearer ${token}`;

            const response = await fetch(`${apiUrl}/auth/me`, {
                credentials: 'include',
                headers
            });

            if (!response.ok) {
                if (response.status === 401 || response.status === 403) {
                    clearLegacyTokens();
                    clearSessionHintCookie();
                }
                return null;
            }

            const userData = await response.json().catch(() => ({}));
            const accountType = userData.data?.user?.account_type || userData.user?.account_type || null;
            /* debug removed: account type detectado */
            return accountType || 'business';
        } catch (error) {
            /* debug removed: error verificando tipo de usuario */
        }

        return null;
    }

    function getApiBaseURL() {
        try {
            const hostname = String(window.location.hostname || '');
            const isLocal = /localhost|127\.0\.0\.1/.test(hostname);
            if (isLocal) {
                return `${window.location.protocol}//${window.location.hostname}:3000/api/v1`;
            }

            const prodApi = '/api/v1';

            // If apiConfig exists and points to a different valid host, keep it; otherwise force prodApi
            const candidate = (window.apiConfig && window.apiConfig.baseURL) ? String(window.apiConfig.baseURL) : '';
            if (candidate) {
                // If it's mistakenly set to current origin (/api/v1) on a CDN subdomain, it will break auth
                const usesOrigin = candidate.startsWith(String(window.location.origin));
                if (!usesOrigin) return candidate;
            }

            return prodApi;
        } catch (_) {
            return '/api/v1';
        }
    }

    function getAccessToken() {
        try {
            const direct = (() => {
                try { return localStorage.getItem('access_token'); } catch { return null; }
            })();
            if (direct) return direct;

            const sessionDirect = (() => {
                try { return sessionStorage.getItem('access_token'); } catch { return null; }
            })();
            if (sessionDirect) return sessionDirect;

            // Backwards compatibility: some pages/scripts store a serialized supabase token
            const supaRaw = (() => {
                try { return localStorage.getItem('supabase.auth.token'); } catch { return null; }
            })() || (() => {
                try { return sessionStorage.getItem('supabase.auth.token'); } catch { return null; }
            })();

            if (supaRaw) {
                try {
                    const parsed = JSON.parse(supaRaw);
                    if (parsed && typeof parsed === 'object') {
                        if (parsed.access_token) return parsed.access_token;
                        // Common nesting patterns
                        if (parsed.currentSession && parsed.currentSession.access_token) return parsed.currentSession.access_token;
                        if (parsed.session && parsed.session.access_token) return parsed.session.access_token;
                    }
                } catch (_) {
                    // Some implementations store the token directly as a string
                    if (typeof supaRaw === 'string' && supaRaw.split('.').length === 3) return supaRaw;
                }
            }
        } catch (_) {}

        return null;
    }

    /**
     * Configura la autenticación dinámica del menú
     */
    async function setupAuthenticationUI() {
        const token = getAccessToken();
        const accountType = await checkUserTypeForMenu();
        const isLoggedIn = !!accountType;
        
        // Buscar botones de autenticación en el menú desktop
        const desktopAuthBtn = document.querySelector('.nav-actions .btn-nav.btn-outline');
        
        // Buscar enlaces de autenticación en el menú móvil y desktop
        const mobileAuthLinks = document.querySelectorAll('.mobile-menu a[href*="login"], .mobile-menu a[href*="dashboard"]');
        const loginBtn = document.getElementById('login-btn')
            || document.querySelector('.nav-actions a[href*="login"], .nav-actions a[href$="login.html"]');
        const miVitrineBtn = document.getElementById('vitrina-btn')
            || document.querySelector('.nav-actions a[href*="user-dashboard"], .nav-actions a[href$="user-dashboard.html"]');
        
        // Elementos móviles de mensajes y perfil
        const mobileMessagesLink = document.getElementById('mobile-messages-link');
        const mobileProfileAvatar = document.getElementById('mobile-profile-avatar');
        const mobileAvatarImage = document.getElementById('mobile-avatar-image');
        const mobileMessagesBadge = document.getElementById('mobile-messages-badge');
        
        /* debug removed: setupAuthenticationUI ejecutándose */
        
        if (isLoggedIn) {
            // Verificar tipo de usuario para mostrar texto correcto
            /* debug removed: Usuario logueado, verificando tipo */
            try {
                const menuText = 'Mi Vitrina'; // Simplificado - solo business dashboard
                const dashboardUrl = '/user-dashboard.html'; // Solo user-dashboard
                
                // Usuario logueado: manejar botones según tipo de cuenta
                /* debug removed: configurando menú y botones */
                
                if (accountType === 'individual') {
                    // Para visitantes: ocultar "Mi Vitrina" y cambiar "Iniciar Sesión" por "Mi Espacio"
                    /* debug removed: configurando visitante */
                    if (miVitrineBtn) {
                        miVitrineBtn.style.display = 'none';
                        /* debug removed */
                    }
                    if (loginBtn) {
                        loginBtn.replaceChildren();
                        const i = document.createElement('i');
                        i.className = 'fas fa-user-circle';
                        loginBtn.appendChild(i);
                        loginBtn.appendChild(document.createTextNode(' Mi Espacio'));
                        loginBtn.href = '/mi-espacio.html';
                        loginBtn.classList.add('active');
                        /* debug removed */
                    }
                } else {
                    // Para negocios: OCULTAR "Mi Vitrina" duplicado y cambiar "Iniciar Sesión" por "Mi Vitrina"
                    /* debug removed: configurando negocio */
                    if (miVitrineBtn) {
                        miVitrineBtn.style.display = 'none';
                        /* debug removed */
                    }
                    if (loginBtn) {
                        loginBtn.replaceChildren();
                        const i = document.createElement('i');
                        i.className = 'fas fa-store';
                        loginBtn.appendChild(i);
                        loginBtn.appendChild(document.createTextNode(' Mi Vitrina'));
                        loginBtn.href = '/user-dashboard.html';
                        loginBtn.classList.add('active');
                        /* debug removed */
                    }
                }
                
                // Actualizar menú móvil
                mobileAuthLinks.forEach(link => {
                    if (link.href.includes('login')) {
                        link.replaceChildren();
                        const i = document.createElement('i');
                        i.className = 'fas fa-user-circle';
                        link.appendChild(i);
                        link.appendChild(document.createTextNode(` ${menuText}`));
                        link.href = dashboardUrl;
                    }
                });
                
                // Mostrar elementos móviles (mensajes + perfil)
                if (mobileMessagesLink) mobileMessagesLink.style.display = 'flex';
                if (mobileProfileAvatar) mobileProfileAvatar.style.display = 'block';
                
                // Cargar avatar del usuario
                try {
                    const userData = localStorage.getItem('user_data');
                    if (userData) {
                        const user = JSON.parse(userData);
                        const avatarUrl = user.avatar_url || `https://ui-avatars.com/api/?name=${encodeURIComponent(user.name || 'Usuario')}&background=4A90E2&color=fff&size=128`;
                        if (mobileAvatarImage) mobileAvatarImage.src = avatarUrl;
                    }
                } catch (e) {
                    console.error('Error cargando avatar móvil:', e);
                }
            } catch (e) {}
        } else {
            // Usuario no logueado: ocultar "Mi Vitrina" y mostrar "Iniciar Sesión"
            if (miVitrineBtn) {
                miVitrineBtn.style.display = 'none';
            }
            if (loginBtn) {
                loginBtn.replaceChildren();
                const i = document.createElement('i');
                i.className = 'fas fa-sign-in-alt';
                loginBtn.appendChild(i);
                loginBtn.appendChild(document.createTextNode(' Iniciar Sesión'));
                loginBtn.href = 'login.html';
                loginBtn.classList.remove('active');
            }
            
            // Ocultar elementos móviles
            if (mobileMessagesLink) mobileMessagesLink.style.display = 'none';
            if (mobileProfileAvatar) mobileProfileAvatar.style.display = 'none';
            
            // Actualizar menú móvil
            mobileAuthLinks.forEach(link => {
                if (link.href.includes('dashboard')) {
                    link.replaceChildren();
                    const i = document.createElement('i');
                    i.className = 'fas fa-sign-in-alt';
                    link.appendChild(i);
                    link.appendChild(document.createTextNode(' Iniciar Sesión'));
                    link.href = 'login.html';
                }
            });
        }
        
        // Escuchar cambios en el localStorage para actualizar dinámicamente
        window.addEventListener('storage', function(e) {
            if (e.key === 'access_token') {
                setupAuthenticationUI();
            }
        });
        
        // También escuchar eventos personalizados para cambios de autenticación
        window.addEventListener('authStateChanged', function() {
            setupAuthenticationUI();
        });
    }
    
    /**
     * Configura características de accesibilidad
     */
    function setupAccessibility() {
        // Configurar aria-labels
        if (mobileMenuToggle) {
            mobileMenuToggle.setAttribute('aria-label', 'Abrir menú de navegación');
            mobileMenuToggle.setAttribute('aria-expanded', 'false');
            mobileMenuToggle.setAttribute('aria-controls', isDashboard ? 'sidebar' : 'mobile-menu');
        }
        
        if (!isDashboard && mobileMenu) {
            mobileMenu.setAttribute('id', 'mobile-menu');
            mobileMenu.setAttribute('role', 'navigation');
            mobileMenu.setAttribute('aria-label', 'Menú principal');
        }
        
        // Configurar navegación por teclado en el menú móvil
        const mobileMenuItems = document.querySelectorAll('.mobile-menu-item');
        mobileMenuItems.forEach((item, index) => {
            item.addEventListener('keydown', function(e) {
                if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    const nextItem = mobileMenuItems[index + 1];
                    if (nextItem) nextItem.focus();
                } else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    const prevItem = mobileMenuItems[index - 1];
                    if (prevItem) prevItem.focus();
                }
            });
        });
    }

    /**
     * Función pública para cerrar el menú (puede ser llamada desde fuera)
     */
    window.NavigationUnified = {
        closeMobileMenu: closeMobileMenu,
        openMobileMenu: openMobileMenu,
        toggleMobileMenu: toggleMobileMenu,
        closeAllDropdowns: closeAllDropdowns,
        updateAuthUI: setupAuthenticationUI
    };

    /**
     * Smooth scroll para enlaces internos
     */
    document.addEventListener('click', function(e) {
        const link = e.target.closest('a[href^="#"]');
        if (link) {
            const targetId = link.getAttribute('href').substring(1);
            const targetElement = document.getElementById(targetId);
            
            if (targetElement) {
                e.preventDefault();
                
                // Cerrar menú móvil si está abierto
                if (isMenuOpen) {
                    closeMobileMenu();
                }
                
                // Scroll suave sin medir layout: usar scroll-padding-top configurado
                try {
                    if (!document.documentElement.style.scrollPaddingTop) {
                        document.documentElement.style.scrollPaddingTop = (headerHeightCached + 20) + 'px';
                    }
                } catch(_){}
                targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }
    });

    /**
     * Preloader para mejorar la experiencia
     */
    function showLoadingState() {
        const navLinks = document.querySelectorAll('.nav-link, .mobile-menu-item');
        navLinks.forEach(link => {
            link.addEventListener('click', function(e) {
                if (this.href && !this.href.includes('#') && !this.target) {
                    this.style.opacity = '0.6';
                    this.style.pointerEvents = 'none';
                }
            });
        });
    }

    // Inicializar loading state
    showLoadingState();

    /**
     * Inserta un enlace "Donaciones" en el footer general si falta
     */
    function addDonationFooterLink(){
        // Buscar columnas de enlaces en el footer
        const footer = document.querySelector('.footer');
        if (!footer) return;
        const lists = footer.querySelectorAll('.footer-links ul');
        if (!lists || lists.length === 0) return;

        // Si ya existe un enlace a donacion.html, no hacer nada
        if (footer.querySelector('a[href$="donacion.html"], a[href="/donacion.html"]')) return;

        // Preferir la primera columna de "Enlaces Rápidos"
        const targetList = lists[0];
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = 'donacion.html';
        a.textContent = 'Donaciones';
        li.appendChild(a);
        targetList.appendChild(li);
    }

})();

/* =======================================
   UTILIDADES ADICIONALES
   ======================================= */

/**
 * Función para actualizar el contador de notificaciones (si se necesita en el futuro)
 */
function updateNotificationCount(count) {
    const badge = document.querySelector('.notification-badge');
    if (badge) {
        if (count > 0) {
            badge.textContent = count > 99 ? '99+' : count;
            badge.style.display = 'block';
        } else {
            badge.style.display = 'none';
        }
    }
}

/**
 * Función para destacar una sección del menú
 */
function highlightMenuSection(sectionName) {
    const menuItems = document.querySelectorAll('.nav-link, .mobile-menu-item');
    menuItems.forEach(item => {
        if (item.textContent.toLowerCase().includes(sectionName.toLowerCase())) {
            item.classList.add('highlighted');
            setTimeout(() => {
                item.classList.remove('highlighted');
            }, 2000);
        }
    });
}

/**
 * Función para añadir estilos de highlight temporal
 */
const highlightStyles = `
    .nav-link.highlighted,
    .mobile-menu-item.highlighted {
        background: var(--warning) !important;
        color: var(--gray-900) !important;
        animation: pulse 0.5s ease-in-out;
    }
    
    @keyframes pulse {
        0% { transform: scale(1); }
        50% { transform: scale(1.05); }
        100% { transform: scale(1); }
    }
`;

// Añadir estilos de highlight al head
if (!document.querySelector('#navigation-highlight-styles')) {
    const styleSheet = document.createElement('style');
    styleSheet.id = 'navigation-highlight-styles';
    styleSheet.textContent = highlightStyles;
    document.head.appendChild(styleSheet);
}

/* =======================================
   DOCUMENTACIÓN
   ======================================= */

/*
Este archivo maneja toda la funcionalidad JavaScript del sistema de navegación unificado.

Características:
- Menú hamburguesa responsive con animaciones
- Dropdowns con hover y click
- Scroll effects en el header
- Navegación por teclado accesible
- Smooth scroll para enlaces internos
- Marcado automático de página actual
- Gestión de estados y eventos

API Pública:
- NavigationUnified.closeMobileMenu()
- NavigationUnified.openMobileMenu()
- NavigationUnified.toggleMobileMenu()
- NavigationUnified.closeAllDropdowns()
- updateNotificationCount(count)
- highlightMenuSection(sectionName)

Eventos:
- Se inicializa automáticamente cuando el DOM está listo
- Escucha cambios de tamaño de ventana
- Maneja navegación por teclado
- Gestiona estados de scroll

Mantenimiento:
- Mantener consistencia con navigation-unified.css
- Probar en todos los navegadores
- Verificar accesibilidad regularmente
*/